import React from 'react';

/**
 * 应用外壳（侧边栏 + 面包屑 + 页签栏）是否已经挂在屏幕上。
 *
 * 为什么需要这个信号 —— umi 给**每一个路由组件**都套了一层
 * `<Suspense fallback={loadingComponent}>`（见 @umijs/renderer-react 的
 * RemoteComponent），而 loadingComponent 就是 src/loading.tsx。那一层 Suspense
 * 落在 TabLayout 缓存节点内部，所以同一个 loading.tsx 会在两个完全不同的位置出现：
 *
 * - `plugin-initialState` 阶段：Provider 在最外层，外壳还没渲染 → 全屏启动动画；
 * - 路由 chunk 未就绪：fallback 落在外壳内部 → 只能占内容区，外壳原地复用。
 *
 * 分不清这两者就会出现「切菜单时整个窗口重新加载」——全屏动画把侧边栏和
 * 页签栏一起盖住。Provider 由 TabLayout 的缓存节点区域提供（auth / 独立页面
 * 不走这里，那些页面本来就该全屏）。
 */
export const AppShellContext = React.createContext(false);

/** 当前是否渲染在已挂载的应用外壳内部 */
export const useAppShellMounted = (): boolean => React.useContext(AppShellContext);

export default AppShellContext;